// Labels for license verifications (backend app: license_verifications).

export const CREDENTIAL_TYPE_OPTIONS = [
  { value: 'cna', text: 'CNA' },
  { value: 'medication_aide', text: 'Medication Aide' },
];

// Org-facing status labels. "Unable to verify" means the registry could not be
// checked; it is never shown to orgs as a failure.
export const LICENSE_STATUS_META = {
  pending: { label: 'Pending', variant: 'secondary' },
  verified: { label: 'Verified', variant: 'success' },
  needs_review: { label: 'Needs Review', variant: 'warning' },
  not_verified: { label: 'Not Verified', variant: 'danger' },
  unable_to_verify: { label: 'Verify Manually', variant: 'warning' },
};

// Students only see plain statuses; anything still being worked on is "Pending".
export const STUDENT_LICENSE_STATUS_META = {
  pending: { label: 'Pending', variant: 'secondary' },
  verified: { label: 'Verified', variant: 'success' },
  needs_review: { label: 'Pending', variant: 'secondary' },
  not_verified: { label: 'Not Verified', variant: 'danger' },
  unable_to_verify: { label: 'Pending', variant: 'secondary' },
};

export function credentialTypeLabel(value) {
  const option = CREDENTIAL_TYPE_OPTIONS.find((o) => o.value === value);
  return option ? option.text : value;
}

export const DOCUMENT_KIND_OPTIONS = [
  { value: 'license_card', text: 'License Card' },
  { value: 'registry_screenshot', text: 'Registry Screenshot' },
  { value: 'other', text: 'Other' },
];

export function documentKindLabel(value) {
  const option = DOCUMENT_KIND_OPTIONS.find((o) => o.value === value);
  return option ? option.text : value;
}
